module.exports = __webpack_public_path__ + "img/neck.4b968eb2.svg";